module.exports = __webpack_public_path__ + "img/BC-M1.753ce460.jpg";